<template>
<div class="chapter">
<div class="inner_page">
<div class="MAIN_PAGE" id="d5e395">
<p class="tx12" id="d41151211"><b>First published in Great Britain in 1996 </b></p>
<p class="tx12" id="d41151212"><b>by William Heinemann Ltd, </b></p>
<p class="tx12" id="d41151213"><b>and imprint of Reed International Books Ltd </b><br/><br/></p>
<p class="tx12" id="d128401"><b>Copyright © 1996 by Hugh Laurie </b></p>
<p class="tx12" id="d128402"><b>The</b><b> author has asserted his moral rights.</b><br/><br/></p>
<p class="tx12" id="d41151351"><b>All rights reserved.</b><br/><br/></p>
<p class="tx12" id="d41151381"><b>Published by </b></p>
<p class="tx12" id="d41151382"><b>Soho Press, Inc.</b></p>
<p class="tx12" id="d41151383"><b>853 Broadway </b></p>
<p class="tx12" id="d41151384"><b>New York NY 10003 </b><br/><br/></p>
<div class="tx41">
<p class="tx12" id="d128541"><b>Library of Congress Catalog in Publishing Data </b><br/><br/></p>
</div>
<p class="tx2" id="d128661"><b>Laurie, Hugh, 1959-</b></p>
<p class="tx2" id="d128662"><b>The gun seller / Hugh Laurie </b></p>
<p class="tx2" id="d128663"><b>p. cm.</b></p>
<p class="tx2" id="d41151561"><b>ISBN 1-56947-087-1 (alk. paper) </b></p>
<p class="tx2" id="d41151562"><b>I. Tide.</b></p>
<p class="tx2" id="d41151611"><b>PR6062.A8139G8 1997 </b></p>
<p class="tx13" id="d128921"><b>823' .914-dc21</b></p>
<p class="tx13" style="text-align:right;margin-right: 20%;margin-top:-1em;"><b>96-46813 </b><br/><b>CIP </b></p>
<p class="tx13a" id="d129001"></p>
<div class="tx42">
</div>
<p class="tx2" id="d129071"><b>10  9  8 7 6  5 4 3 2 </b></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap5_thegunse_9781569478004_epub_part5.vue?b9fd26d4